import script from "./OnboardingTour.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingTour.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingTour.vue?vue&type=style&index=0&id=b5c03dec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5c03dec"]])

export default __exports__